import React from 'react'
import { Stack } from '@mui/material'
import { B2CRegistryUploadDataDialog } from '@/pages/b2c-registry/components/b2c-registry-upload-data-dialog.tsx'
import {
  defaultSettings as DEFAULT_SETTINGS_PAYMENTS,
  KEY_PAGE as KEY_PAGE_B2C_PAYMENTS,
  PartialPaymentsRequest,
} from '@/pages/b2c/default-settings-payments.tsx'
import { PersonCustomizationDialog } from '@/components/person-customization-dialog.tsx'
import { RowProps } from '@/components/dnd-area/draggable-row.tsx'
import { useMutatePersonalSettings } from '@/services'
import { useAppSelector } from '@/stores/hooks.ts'
import { userSelectors } from '@/stores/slices/user-slice.ts'

export const B2CRegistryActionButtons = (): React.ReactElement => {
  const settingsForPayments = useAppSelector((state) => userSelectors.personalSettings(state, KEY_PAGE_B2C_PAYMENTS))

  const getSettingsPayments = (format: string, personalSettings?: Record<string, string[]>) => {
    const settingsByRequest = personalSettings?.[format] ?? Object.keys(DEFAULT_SETTINGS_PAYMENTS)
    const settings: RowProps[] = settingsByRequest.map((e) => ({
      id: e,
      label: DEFAULT_SETTINGS_PAYMENTS[e as keyof PartialPaymentsRequest],
      isChecked: true,
    }))
    Object.keys(DEFAULT_SETTINGS_PAYMENTS).forEach((key) => {
      if (!settingsByRequest.includes(key)) {
        settings.push({
          id: key,
          label: DEFAULT_SETTINGS_PAYMENTS[key as keyof PartialPaymentsRequest],
          isChecked: false,
        })
      }
    })

    return settings
  }

  return (
    <Stack
      direction={{ sm: 'column', px526: 'row' }}
      gap={2}
      justifyContent={{ sm: 'flex-start', px526: 'flex-end' }}
      alignItems="flex-start"
    >
      <B2CRegistryUploadDataDialog />
      <PersonCustomizationDialog
        personalSettingsKey={KEY_PAGE_B2C_PAYMENTS}
        mutation={useMutatePersonalSettings()}
        itemsDesktop={getSettingsPayments('desktop', settingsForPayments)}
        itemsMobile={getSettingsPayments('mobile', settingsForPayments)}
      />
    </Stack>
  )
}
